/* eslint-disable max-len */
export const V_LAYOUTS = {
	ZERO: 'wallpaper',
	ONE: {
		FULL: 'single cover',
		FULL_PADDING: 'single-padding cover',
		HALF: 'half cover',
	},
	TWO: {
		FULL_TWO: 'double cover',
		VERTICAL: {
			COVER: 'vertical two cover',
			CONTAIN: 'vertical two contain',
		},
		HORIZONTAL: {
			COVER: 'horizontal two cover',
			CONTAIN: 'horizontal two contain',
		},
		STACK: {
			RIGHT: {
				CONTAIN: 'stack two right contain',
			},
		},
		SHIFTED: 'horizontal two-shifted contain',
		SPACED: 'horizontal two spaced',
		// We check for "media" in these type names in main-video to ignore
		// spacing layouts since these are already calculated for media proportions.
		// So if changing the name of these, keep "media" in them.
		MEDIA: {
			SIXTEEN_BY_NINE: 'media two sixteen-by-nine cover',
			FOUR_BY_THREE: 'media two four-by-three cover',
		},
		PICTURE_IN_PICTURE: {
			BOTTOM_RIGHT: 'picture-in-picture bottom right',
			TOP_LEFT: 'picture-in-picture top left',
		},
	},
	THREE: {
		VERTICAL: {
			COVER: 'vertical three cover',
			CONTAIN: 'vertical three contain',
		},
		HORIZONTAL: {
			COVER: 'horizontal three cover',
			CONTAIN: 'horizontal three contain',
		},
		STACK: {
			LEFT: 'stack three left',
			RIGHT: 'stack three right',
			TOP: 'stack three top',
		},
		SPACED: 'horizontal three spaced',
		// We check for "media" in these type names in main-video to ignore
		// spacing layouts since these are already calculated for media proportions.
		// So if changing the name of these, keep "media" in them.
		MEDIA: {
			SIXTEEN_BY_NINE: 'media three sixteen-by-nine cover',
			FOUR_BY_THREE: 'media three four-by-three cover',
		},
		ASL: {
			DOUBLE_FOUR_BY_THREE: 'asl fixed three double-four-by-three cover',
		},
	},
	FOUR: {
		GRID: 'grid four',
		VERTICAL: {
			COVER: 'vertical four cover',
		},
		SPIRAL: 'spiral four',
		// We check for "media" in these type names in main-video to ignore
		// spacing layouts since these are already calculated for media proportions.
		// So if changing the name of these, keep "media" in them.
		MEDIA: {
			SIXTEEN_BY_NINE: 'media four sixteen-by-nine cover',
			FOUR_BY_THREE: 'media four four-by-three cover',
		},
		ASL: {
			THREE_BY_FOUR: 'asl fixed four three-by-four cover',
			SIXTEEN_BY_NINE: 'asl fixed four sixteen-by-nine cover',
		},
	},
	FIVE: {
		STACK: {
			RIGHT: 'stack five right',
			TOP_LEFT: 'stack five top-left',
			TWO_LEFT: 'stack five two-left',
			FOUR_TOP: 'stack five four-top',
			FOUR_BY_THREE: 'stack five four-by-three cover',
		},
		ASL: {
			NINE_BY_SIXTEEN: 'asl fixed five nine-by-sixteen cover',
		},
	},
	SIX: {
		GRID: 'grid six',
		STACK: {
			RIGHT: 'stack six right',
			LEFT: 'stack six left',
			RANDOM: 'stack six random',
		},
	},
	SEVEN: {
		GRID: 'grid seven',
		STACK: {
			CENTER: 'stack seven center',
		},
	},
	EIGHT: {
		GRID: 'grid eight',
	},
};

export interface VideoLayouts {
	presenters: number;
	layouts: string[];
}

export const LAYOUTS_BY_SIZE: VideoLayouts[] = [
	{
		presenters: 1,
		layouts: [
			V_LAYOUTS.ONE.FULL,
			V_LAYOUTS.ONE.FULL_PADDING,
			V_LAYOUTS.ONE.HALF,
		],
	},
	{
		presenters: 2,
		layouts: [
			V_LAYOUTS.TWO.VERTICAL.COVER,
			V_LAYOUTS.TWO.STACK.RIGHT.CONTAIN,
			V_LAYOUTS.TWO.HORIZONTAL.CONTAIN,
			V_LAYOUTS.TWO.SPACED,
			V_LAYOUTS.TWO.MEDIA.SIXTEEN_BY_NINE,
			V_LAYOUTS.TWO.MEDIA.FOUR_BY_THREE,
			V_LAYOUTS.TWO.PICTURE_IN_PICTURE.BOTTOM_RIGHT,
			V_LAYOUTS.TWO.PICTURE_IN_PICTURE.TOP_LEFT,
		],
	},
	{
		presenters: 3,
		layouts: [
			V_LAYOUTS.THREE.VERTICAL.COVER,
			V_LAYOUTS.THREE.STACK.TOP,
			V_LAYOUTS.THREE.STACK.LEFT,
			V_LAYOUTS.THREE.STACK.RIGHT,
			V_LAYOUTS.THREE.SPACED,
			V_LAYOUTS.THREE.MEDIA.SIXTEEN_BY_NINE,
			V_LAYOUTS.THREE.MEDIA.FOUR_BY_THREE,
			V_LAYOUTS.THREE.ASL.DOUBLE_FOUR_BY_THREE,
		],
	},
	{
		presenters: 4,
		layouts: [
			V_LAYOUTS.FOUR.GRID,
			V_LAYOUTS.FOUR.VERTICAL.COVER,
			V_LAYOUTS.FOUR.SPIRAL,
			V_LAYOUTS.FOUR.MEDIA.SIXTEEN_BY_NINE,
			V_LAYOUTS.FOUR.MEDIA.FOUR_BY_THREE,
			V_LAYOUTS.FOUR.ASL.THREE_BY_FOUR,
			V_LAYOUTS.FOUR.ASL.SIXTEEN_BY_NINE,
		],
	},
	{
		presenters: 5,
		layouts: [
			V_LAYOUTS.FIVE.STACK.FOUR_BY_THREE,
			V_LAYOUTS.FIVE.STACK.RIGHT,
			V_LAYOUTS.FIVE.STACK.TOP_LEFT,
			V_LAYOUTS.FIVE.STACK.TWO_LEFT,
			V_LAYOUTS.FIVE.STACK.FOUR_TOP,
			V_LAYOUTS.FIVE.ASL.NINE_BY_SIXTEEN,
		],
	},
	{
		presenters: 6,
		layouts: [
			V_LAYOUTS.SIX.GRID,
			V_LAYOUTS.SIX.STACK.RIGHT,
			V_LAYOUTS.SIX.STACK.LEFT,
			V_LAYOUTS.SIX.STACK.RANDOM,
		],
	},
	{
		presenters: 7,
		layouts: [
			V_LAYOUTS.SEVEN.GRID,
			V_LAYOUTS.SEVEN.STACK.CENTER,
		],
	},
	{
		presenters: 8,
		layouts: [V_LAYOUTS.EIGHT.GRID],
	},
];

export const PIP_LAYOUTS = [
	V_LAYOUTS.TWO.PICTURE_IN_PICTURE.BOTTOM_RIGHT,
	V_LAYOUTS.TWO.PICTURE_IN_PICTURE.TOP_LEFT,
];

// These are layouts that have fixed spacing, for media items
export const FIXED_LAYOUTS = [
	V_LAYOUTS.TWO.MEDIA.SIXTEEN_BY_NINE,
	V_LAYOUTS.TWO.MEDIA.FOUR_BY_THREE,
	V_LAYOUTS.THREE.MEDIA.SIXTEEN_BY_NINE,
	V_LAYOUTS.THREE.MEDIA.FOUR_BY_THREE,
	V_LAYOUTS.FOUR.MEDIA.SIXTEEN_BY_NINE,
	V_LAYOUTS.FOUR.MEDIA.FOUR_BY_THREE,
	V_LAYOUTS.THREE.ASL.DOUBLE_FOUR_BY_THREE,
	V_LAYOUTS.FOUR.ASL.THREE_BY_FOUR,
	V_LAYOUTS.FOUR.ASL.SIXTEEN_BY_NINE,
	V_LAYOUTS.FIVE.ASL.NINE_BY_SIXTEEN,
	...PIP_LAYOUTS,
];

// These are layouts that have no spacing, border, or rounded corners
export const PLAIN_LAYOUTS = [
	V_LAYOUTS.ONE.FULL,
];

export const fixedLayoutTypes = ['fixed', 'media'];

export default V_LAYOUTS;

export function getVisiblePresentersFromLayout(layout: string) {
	let returnedNumber = 0;
	LAYOUTS_BY_SIZE.forEach((layoutGroup: VideoLayouts) => {
		layoutGroup.layouts.forEach((layoutString: string) => {
			if (layoutString === layout) {
				returnedNumber = layoutGroup.presenters;
			}
		});
	});
	return returnedNumber;
}

export function isOneUpLayout(layout: string) {
	return layout === V_LAYOUTS.ONE.FULL
		|| layout === V_LAYOUTS.ONE.FULL_PADDING
		|| layout === V_LAYOUTS.ONE.HALF;
}

export function isTwoUpLayout(layout: string) {
	return layout === V_LAYOUTS.TWO.VERTICAL.COVER
		|| layout === V_LAYOUTS.TWO.STACK.RIGHT.CONTAIN
		|| layout === V_LAYOUTS.TWO.HORIZONTAL.CONTAIN
		|| layout === V_LAYOUTS.TWO.SPACED
		|| layout === V_LAYOUTS.TWO.MEDIA.SIXTEEN_BY_NINE
		|| layout === V_LAYOUTS.TWO.MEDIA.FOUR_BY_THREE
		|| layout === V_LAYOUTS.TWO.PICTURE_IN_PICTURE.BOTTOM_RIGHT
		|| layout === V_LAYOUTS.TWO.PICTURE_IN_PICTURE.TOP_LEFT
		|| layout === V_LAYOUTS.TWO.FULL_TWO
		|| layout === V_LAYOUTS.TWO.VERTICAL.CONTAIN
		|| layout === V_LAYOUTS.TWO.HORIZONTAL.COVER
		|| layout === V_LAYOUTS.TWO.SHIFTED;
}

// used to determine the canvas layout when an onsite location should be hidden
// a large conditional because there isnt a dynamic way to determine the layout and these will likely be adjusted
export function getOnsiteLayout(layout: string) {
	// if the broadcast uses ANY 2UP layout… the location specific view should use 1A layout
	if (isTwoUpLayout(layout)) return V_LAYOUTS.ONE.FULL;

	// if the broadcast uses the 3A layout… the location specific view should use 2A
	if (layout === V_LAYOUTS.THREE.VERTICAL.COVER) return V_LAYOUTS.TWO.VERTICAL.COVER;

	// if the broadcast uses the 3B layout… the location specific view should use 2D
	if (layout === V_LAYOUTS.THREE.STACK.TOP) return V_LAYOUTS.TWO.SPACED;

	// if the broadcast uses the 3C layout… the location specific view should use 2D
	if (layout === V_LAYOUTS.THREE.STACK.LEFT) return V_LAYOUTS.TWO.SPACED;

	// if the broadcast uses the 3D layout… the location specific view should use 2D
	if (layout === V_LAYOUTS.THREE.STACK.RIGHT) return V_LAYOUTS.TWO.SPACED;

	// if the broadcast uses the 3E layout… the location specific view should use 2A
	if (layout === V_LAYOUTS.THREE.SPACED) return V_LAYOUTS.TWO.VERTICAL.COVER;

	// if the broadcast uses the 3F layout… the location specific view should use 2E
	if (layout === V_LAYOUTS.THREE.MEDIA.SIXTEEN_BY_NINE) return V_LAYOUTS.TWO.MEDIA.SIXTEEN_BY_NINE;

	// if the broadcast uses the 3G layout… the location specific view should use 2F
	if (layout === V_LAYOUTS.THREE.MEDIA.FOUR_BY_THREE) return V_LAYOUTS.TWO.MEDIA.FOUR_BY_THREE;

	// if the broadcast uses the 3H layout… the location specific view should use 2D
	if (layout === V_LAYOUTS.THREE.ASL.DOUBLE_FOUR_BY_THREE) return V_LAYOUTS.TWO.SPACED;

	// if the broadcast uses the 4A layout… the location specific view should use 3B
	if (layout === V_LAYOUTS.FOUR.GRID) return V_LAYOUTS.THREE.STACK.TOP;

	// if the broadcast uses the 4B layout… the location specific view should use 3A
	if (layout === V_LAYOUTS.FOUR.VERTICAL.COVER) return V_LAYOUTS.THREE.VERTICAL.COVER;

	// if the broadcast uses the 4C layout… the location specific view should use 3B
	if (layout === V_LAYOUTS.FOUR.SPIRAL) return V_LAYOUTS.THREE.STACK.TOP;

	// if the broadcast uses the 4D layout… the location specific view should use 3F
	if (layout === V_LAYOUTS.FOUR.MEDIA.SIXTEEN_BY_NINE) return V_LAYOUTS.THREE.MEDIA.SIXTEEN_BY_NINE;

	// if the broadcast uses the 4E layout… the location specific view should use 3G
	if (layout === V_LAYOUTS.FOUR.MEDIA.FOUR_BY_THREE) return V_LAYOUTS.THREE.MEDIA.FOUR_BY_THREE;

	// if the broadcast uses the 4F layout… the location specific view should use 3H
	if (layout === V_LAYOUTS.FOUR.ASL.THREE_BY_FOUR) return V_LAYOUTS.THREE.ASL.DOUBLE_FOUR_BY_THREE;

	// if the broadcast uses the 4G layout… the location specific view should use 3H
	if (layout === V_LAYOUTS.FOUR.ASL.SIXTEEN_BY_NINE) return V_LAYOUTS.THREE.ASL.DOUBLE_FOUR_BY_THREE;

	// if the broadcast uses the 5A layout… the location specific view should use 4A
	if (layout === V_LAYOUTS.FIVE.STACK.FOUR_BY_THREE) return V_LAYOUTS.FOUR.GRID;

	// if the broadcast uses the 5B layout… the location specific view should use 4A
	if (layout === V_LAYOUTS.FIVE.STACK.RIGHT) return V_LAYOUTS.FOUR.GRID;

	// if the broadcast uses the 5C layout… the location specific view should use 4A
	if (layout === V_LAYOUTS.FIVE.STACK.TOP_LEFT) return V_LAYOUTS.FOUR.GRID;

	// if the broadcast uses the 5D layout… the location specific view should use 4A
	if (layout === V_LAYOUTS.FIVE.STACK.TWO_LEFT) return V_LAYOUTS.FOUR.GRID;

	// if the broadcast uses the 5E layout… the location specific view should use 4A
	if (layout === V_LAYOUTS.FIVE.STACK.FOUR_TOP) return V_LAYOUTS.FOUR.GRID;

	// if the broadcast uses the 5F layout… the location specific view should use 4F
	if (layout === V_LAYOUTS.FIVE.ASL.NINE_BY_SIXTEEN) return V_LAYOUTS.FOUR.ASL.THREE_BY_FOUR;

	// if the broadcast uses the 6A layout… the location specific view should use 5A
	if (layout === V_LAYOUTS.SIX.GRID) return V_LAYOUTS.FIVE.STACK.FOUR_BY_THREE;

	// if the broadcast uses the 6B layout… the location specific view should use 5A
	if (layout === V_LAYOUTS.SIX.STACK.RIGHT) return V_LAYOUTS.FIVE.STACK.FOUR_BY_THREE;

	// if the broadcast uses the 6C layout… the location specific view should use 5A
	if (layout === V_LAYOUTS.SIX.STACK.LEFT) return V_LAYOUTS.FIVE.STACK.FOUR_BY_THREE;

	// if the broadcast uses the 6D layout… the location specific view should use 5A
	if (layout === V_LAYOUTS.SIX.STACK.RANDOM) return V_LAYOUTS.FIVE.STACK.FOUR_BY_THREE;

	// if the broadcast uses the 7A layout… the location specific view should use 6A
	if (layout === V_LAYOUTS.SEVEN.GRID) return V_LAYOUTS.SIX.GRID;

	// if the broadcast uses the 7B layout… the location specific view should use 6A
	if (layout === V_LAYOUTS.SEVEN.STACK.CENTER) return V_LAYOUTS.SIX.GRID;

	// if the broadcast uses the 8A layout… the location specific view should use 7A
	if (layout === V_LAYOUTS.EIGHT.GRID) return V_LAYOUTS.SEVEN.GRID;

	return layout;
}
